import { useRef } from "react";
import { toast } from "sonner";
import { trpc } from "@/lib/trpc";
import type { Procedimento } from "./SeletorDeProcedimento";

type Resultado = { procedimento: Procedimento; criado: boolean; especialidadeAdicionadaId: string | null };

/**
 * Adicionar ao catálogo direto do plano, a partir da base. Avisa num toast com "Desfazer";
 * desfeito, chama `onDesfeito` com o id pra tela soltar a seleção.
 */
export function useAdicionarAoCatalogo(onDesfeito: (serviceId: string) => void) {
  const utils = trpc.useUtils();
  const aoDesfazer = useRef(onDesfeito);
  aoDesfazer.current = onDesfeito;
  const invalidar = () => {
    utils.plano.procedimentos.invalidate();
    utils.plano.daBase.invalidate();
    utils.service.invalidate();
    utils.organization.activeSpecialties.invalidate();
  };
  const desfazer = trpc.plano.desfazerAdicao.useMutation({
    onSuccess: (_, v) => {
      invalidar();
      aoDesfazer.current(v.serviceId);
      toast.success("Desfeito: o procedimento saiu do catálogo.");
    },
    onError: (e) => toast.error(e.message),
  });
  const avisar = ({ procedimento: p, criado, especialidadeAdicionadaId }: Resultado) => {
    invalidar();
    if (!criado) return toast.success(`${p.name} já estava no seu catálogo.`);
    toast.success(`${p.name} adicionado ao seu catálogo`, {
      description: especialidadeAdicionadaId ? `${p.especialidade.label} entrou nas especialidades da clínica.` : undefined,
      duration: 10_000,
      action: { label: "Desfazer", onClick: () => desfazer.mutate({ serviceId: p.id, especialidadeId: especialidadeAdicionadaId }) },
    });
  };
  const daBase = trpc.plano.adicionarDaBase.useMutation({ onSuccess: avisar, onError: (e) => toast.error(e.message) });

  return {
    ocupado: daBase.isPending,
    adicionarDaBase: async (procedimentoId: string) => (await daBase.mutateAsync({ procedimentoId })).procedimento as Procedimento,
  };
}
